const draggable = "_35sd1jiy81v";

export { draggable };
import "./atom.draggable.style.linaria.module.css";
//# sourceMappingURL=atom.draggable.style.js.map
